import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { OffboardingAction, OffboardingCase, OffboardingHistory, OffboardingMutation } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey, assetOperationId, workflowTrackBy } from '../common/employee-assets/asset.helpers';
import { OFFBOARDING as O } from './offboarding.constants';

@Component({selector: 'app-offboarding-item', templateUrl: './offboarding-item.component.html',
  styleUrls: ['./offboarding-sequential.component.css', './offboarding-workspace-content.css']})
export class OffboardingItemComponent implements OnChanges, OnDestroy {
  @Input() item: OffboardingCase;
  @Input() row: OffboardingAction;
  @Input() events: OffboardingHistory[] = [];
  @Input() disabled = false;
  @Input() finalStage = false;
  @Input() historyMore = false;
  @Input() historyLoading = false;
  @Input() visible = true;
  @Output() saved = new EventEmitter<OffboardingCase>();
  @Output() refresh = new EventEmitter<void>();
  @Output() loadMore = new EventEmitter<void>();
  trackBy = workflowTrackBy;
  constants = O;
  assetConstants = ASSET;
  history: OffboardingHistory[] = [];
  vacationBalance: number;
  missingQuantity = ASSET.zero;
  nonApplicable = false;
  reason = ASSET.empty;
  confirmed = false;
  note = ASSET.empty;
  noteOpen = false;
  busy = false;
  collectionBusy = false;
  errorKey = ASSET.empty;
  noteError = ASSET.empty;
  private pending: OffboardingMutation;
  private notePending: OffboardingMutation;
  private submittedContent = ASSET.empty;
  private submittedNote = ASSET.empty;
  private destroyed = new Subject<void>();
  constructor(private api: OffboardingService) {}
  ngOnChanges(): void { this.history = this.events.filter(event => event.key === this.row.key && event.action !== O.addNote); }
  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }
  get canConfirm(): boolean {
    return !!this.row.canConfirm && !this.busy && !this.disabled && this.confirmed && this.validInput
      && this.errorKey !== ASSET.conflictKey && this.errorKey !== ASSET.deniedKey;
  }
  get collection(): boolean { return this.row.inputKind === O.assetReturn || this.row.inputKind === O.clothingReturn; }
  get validInput(): boolean {
    if (this.row.inputKind === O.number) { return this.vacationBalance != null && this.vacationBalance >= ASSET.zero; }
    if (this.nonApplicable) { return !!this.reason.trim(); }
    if (this.row.inputKind === O.badge) { return this.missingQuantity != null && this.missingQuantity >= ASSET.zero
      && this.missingQuantity % ASSET.one === ASSET.zero && (!this.missingQuantity || !!this.reason.trim()); }
    return true;
  }
  confirm(): void {
    if (!this.canConfirm) { return; }
    const content = JSON.stringify([this.vacationBalance, this.missingQuantity, this.nonApplicable, this.reason]);
    if (!this.pending || this.submittedContent !== content) { this.pending = this.confirmationRequest(); }
    this.submittedContent = content; this.busy = true; this.errorKey = ASSET.empty;
    this.api.act(this.item.id, this.pending).takeUntil(this.destroyed).subscribe(result => {
      this.busy = false; this.pending = null; this.confirmed = false; this.saved.emit(result);
    }, error => { this.busy = false; this.errorKey = assetErrorKey(error, true); });
  }
  addNote(): void {
    const note = this.note.trim();
    if (this.busy || this.collectionBusy || this.disabled || !this.row.canAddNote || !note || note.length > O.noteMax || this.noteError === ASSET.conflictKey || this.noteError === ASSET.deniedKey) { return; }
    if (!this.notePending || note !== this.submittedNote) {
      this.notePending = {operationId: assetOperationId(), expectedVersion: this.item.version, action: O.addNote, key: this.row.key, note: note};
    }
    this.submittedNote = note; this.busy = true; this.noteError = ASSET.empty;
    this.api.act(this.item.id, this.notePending).takeUntil(this.destroyed).subscribe(result => {
      this.busy = false; this.note = ASSET.empty; this.notePending = null; this.noteOpen = false; this.saved.emit(result);
    }, error => { this.busy = false; this.noteError = assetErrorKey(error, true); });
  }
  checkCurrent(): void {
    if (this.busy || this.collectionBusy || this.disabled) { return; }
    this.pending = null; this.notePending = null; this.errorKey = ASSET.empty; this.noteError = ASSET.empty;
    this.confirmed = false; this.refresh.emit();
  }
  private confirmationRequest(): OffboardingMutation {
    return {operationId: assetOperationId(), expectedVersion: this.item.version, action: O.confirm, key: this.row.key,
      vacationBalance: this.vacationBalance, missingQuantity: this.row.inputKind === O.badge ? this.nonApplicable ? ASSET.zero : this.missingQuantity : undefined,
      nonApplicable: this.nonApplicable, reason: this.reason.trim(), evidence: this.reason.trim()};
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-item.component.ts